var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.325 11.147C34.8191 10.2538 35.937 8.84737 36.47 7.19031C35.0661 8.02331 33.5301 8.6101 31.9283 8.92531C29.7076 6.57619 26.1892 6.00452 23.339 7.52973C20.4888 9.05495 19.0125 12.2995 19.735 15.4503C13.9843 15.1616 8.62661 12.4452 4.995 7.97697C3.09973 11.246 4.06825 15.4249 7.20833 17.527C6.07284 17.4905 4.96254 17.183 3.97 16.6303C3.97 16.6603 3.97 16.6903 3.97 16.7203C3.97065 20.1256 6.37062 23.0588 9.70833 23.7336C8.6551 24.0202 7.55034 24.0624 6.47833 23.857C7.417 26.7691 10.1009 28.7641 13.16 28.8236C10.6264 30.8122 7.49746 31.8906 4.27666 31.8853C3.70578 31.8861 3.13535 31.8533 2.56833 31.787C5.83898 33.8887 9.64561 35.0042 13.5333 35.0003C18.9421 35.0375 24.14 32.9051 27.9645 29.0803C31.789 25.2555 33.9209 20.0574 33.8833 14.6486C33.8833 14.3386 33.8761 14.0303 33.8617 13.7236C35.2624 12.7113 36.4714 11.4572 37.4317 10.0203C36.1267 10.5987 34.7425 10.9785 33.325 11.147Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.4ab57a433abb2aaee53e65d7f7e619ed.svg";
export { ForwardRef as ReactComponent };